import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { getStoreDescription } from '../storeTypes';


export default /*#__PURE__*/_defineComponent({
  __name: 'StoreDescription',
  props: {
    storeType: null
  },
  setup(__props: any) {

const props = __props as {
    storeType: string;
};



const description = computed(() => getStoreDescription(props.storeType));

return { __sfc: true,props, description }
}

})